import { LayoutConfig } from "../types";

// 관리자 설정 목업 — 추후 API로 교체
export const layoutConfig: LayoutConfig = {
  emergencyNotice: {
    visible: true,
    messages: [
      "현재 도메인 변경작업 진행 중입니다. 작업이 완료되면 변경된 도메인으로 접속해주세요.",
      "3/28(목) 03:00~05:00 서버 점검이 예정되어 있습니다.",
      "사칭 업체 주의! OFF 공식 채널만 이용해주세요.",
    ],
  },
  vip: {
    height: 240,
    count: 5,
    intervalMs: 3000, // #438-3: 광고 전환 간격 3초
    visible: true,
  },
  platinum: {
    height: 160,
    count: 6,
    intervalMs: 4000,
    visible: true,
  },
  gold: {
    height: 130,
    count: 9,
    intervalMs: 3500,
    visible: true,
  },
  standard: {
    height: 160,
    count: 50,
    intervalMs: 0,
    visible: true,
    minCardWidth: 140,
  },
};
